import firstImgage from "../../../images/decor/equinox_wall_decor/1.avif"
import secondImgage from "../../../images/decor/equinox_wall_decor/2.avif"
import mainImage from "../../../images/decor/equinox_wall_decor/main.avif"



export const EquinoxWallDecor =  {
    name:"Equinox Wall Decor",
    code:'NDEQX100',
    type:"Decor",
    images:[firstImgage, secondImgage],
    main_image:mainImage,
    description:[
            "Embrace tranquility with Equinox Wall Decor, a zen-inspired piece that artfully combines steel frames with natural wooden branches. Designed to bring a serene and balanced aesthetic to your space, Equinox effortlessly merges industrial elements with organic beauty.",
            "The sleek steel frames provide a modern, minimalist structure, while the wooden branches add a touch of natural warmth and texture. Each branch is uniquely shaped, creating a harmonious contrast with the geometric precision of the steel. This combination evokes a sense of calm and equilibrium, perfect for creating a peaceful atmosphere in any room.",
            "Ideal for contemporary homes and tranquil spaces, Equinox Wall Decor transforms your wall into a serene focal point, where nature and modern design converge in elegant simplicity."
    ],
    information:"A zen-inspired wall art piece featuring a minimalist steel frame paired with natural wooden branches. This unique design blends industrial and organic elements to create a serene focal point, perfect for adding a touch of tranquility to any space.",
}
